export default function Avatar({ user, size = "md" }) {
  const sizes = {
    sm: "w-6 h-6 text-xs",
    md: "w-10 h-10 text-sm",
    lg: "w-20 h-20 text-2xl",
  };

  const cls = sizes[size] || sizes.md;

  if (user.avatar_url) {
    return (
      <img
        src={user.avatar_url}
        alt={user.display_name}
        className={`${cls} rounded-full object-cover`}
      />
    );
  }

  return (
    <div className={`${cls} rounded-full bg-stone/30 flex items-center justify-center`}>
      <span className="font-display font-bold text-walnut-light">
        {user.display_name.charAt(0)}
      </span>
    </div>
  );
}
